import { render, staticRenderFns } from "./repair_record_detail_dialog.vue?vue&type=template&id=5bc996d3&scoped=true"
import script from "./repair_record_detail_dialog.vue?vue&type=script&lang=js"
export * from "./repair_record_detail_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc996d3",
  null
  
)

export default component.exports